import React from "react"
import { ListboxInput, ListboxPopover, ListboxList } from "@reach/listbox"
import "@reach/listbox/styles.css"

import { useUID } from "utils"

import Button from "./_Button"
import Option from "./_Option"
import { labelStyles, errorStyles } from "./ListBox.styles"

function ListBox({
  id,
  label,
  options,
  error,
  placeholder = "Select an option",
  ...rest
}) {
  const generatedId = useUID()
  const labelId = id || generatedId

  return (
    <div data-component="ListBox">
      {label && (
        <label className={labelStyles(error)} id={labelId}>
          {label}
        </label>
      )}
      <ListboxInput
        aria-labelledby={labelId}
        defaultValue="placeholder"
        {...rest}
      >
        {({ value, valueLabel, isExpanded }) => (
          <>
            <Button value={value} valueLabel={valueLabel} error={error} />
            <ListboxPopover className="list-box">
              <ListboxList>
                <Option
                  label={placeholder}
                  value="placeholder"
                  disabled={true}
                />
                {options.map((option, i) => (
                  <Option
                    label={option.label}
                    value={option.value}
                    key={option.value}
                  />
                ))}
              </ListboxList>
            </ListboxPopover>
          </>
        )}
      </ListboxInput>
      {error && (
        <p role="alert" className={errorStyles}>
          {error}
        </p>
      )}
    </div>
  )
}
export default ListBox
